import { z } from "zod";

const liveQuoteSchema = z.object({
  price: z.number().optional(),
  previousClose: z.number().optional(),
});

const clientFrameSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("symbols"), symbols: z.array(z.string()) }),
  z.object({ type: z.literal("visibility"), visible: z.boolean() }),
  z.object({
    type: z.literal("account"),
    key: z.string(),
    socketUrl: z.string(),
  }),
  z.object({ type: z.literal("token"), token: z.string() }),
  z.object({ type: z.literal("bye") }),
]);

const hostFrameSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("quotes"),
    // The account this batch was fetched for. A window drops the frame if
    // this does not match the account it currently believes it is on —
    // see `SnapshotStream.context.tsx`.
    account: z.string(),
    quotes: z.record(z.string(), liveQuoteSchema),
  }),
  z.object({ type: z.literal("tokenRequest") }),
  // Sent once per connection, before anything else. The window uses it to
  // decide the worker actually came up; see `createFailoverTransport`.
  z.object({ type: z.literal("ready") }),
]);

export type ClientFrame = z.infer<typeof clientFrameSchema>;
export type HostFrame = z.infer<typeof hostFrameSchema>;

export const parseClientFrame = (value: unknown): ClientFrame | undefined => {
  const result = clientFrameSchema.safeParse(value);
  return result.success ? result.data : undefined;
};

export const parseHostFrame = (value: unknown): HostFrame | undefined => {
  const result = hostFrameSchema.safeParse(value);
  return result.success ? result.data : undefined;
};
